import { ApiClient, TranslationProvider, MapManager, MapNavigator } from "wonder-image";

window.ApiClient = ApiClient;
window.TranslationProvider = TranslationProvider;
window.MapManager = MapManager;
window.MapNavigator = MapNavigator;

window.API_CLIENT = new ApiClient(pathSite+'/api', typeof API_TOKEN !== 'undefined' ? API_TOKEN : '');
window.API_CLIENT_APP = window.API_CLIENT;

// Token del meta wi-csrf per l'header X-WI-CSRF (con url: solo stessa origine)
window.wiCsrfToken = function(url) {
    return ApiClient.csrfToken(url);
}

window.__t = function(key, replacements = []) {
    return TranslationProvider.get(key, replacements);
}